import React from "react";
import "./paiement.scss";
import { BookOnline } from "@mui/icons-material";
import { Fab, Skeleton } from "@mui/material";
import { truncateToFixed } from "../../_services/utils";

const Header = ({
  totalPerMonth,
  totalPerDay,
  amountPerMonth,
  amountPerDay,
  onClickHistorique,
  loading,
}) => {
  const SK_COUNT = 3;
  const skeletonCard = (
    <Skeleton
      variant="rounded"
      sx={{ width: "98%", height: "100px", padding: "0px" }}
    />
  );

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gap: "10px",
        marginTop: "8px",
      }}
    >
      {loading.isLoading ? (
        // <>{Array(SK_COUNT).fill(skeletonCard)}</>
        <>
          {Array.from({ length: SK_COUNT }, (_, index) => (
            <div key={`skeleton-${index}`}>{skeletonCard}</div>
          ))}
        </>
      ) : (
        <>
          {" "}
          <div className="dashbordItem">
            <div className="dashbordItemUp">
              <div className="dashDesc">
                <div className="descTitle1">Total Paiement</div>
                <div className="descTitle2">Elèves reçus ce mois</div>
              </div>
              <div className="dashIcon">
                <div
                  color=""
                  aria-label="add"
                  style={{
                    width: "90px",
                    height: "50px",
                    backgroundColor: "skyblue",
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span style={{ fontSize: "1rem", fontWeight: "600" }}>
                    {totalPerMonth}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="dashbordItem">
            <div className="dashbordItemUp">
              <div className="dashDesc">
                <div className="descTitle1">Historique mensuel</div>
                <div className="descTitle2">Somme totale perçue ce mois</div>
              </div>
              <div className="dashIcon">
                <div
                  color="success"
                  aria-label="add"
                  style={{
                    width: "90px",
                    height: "50px",
                    backgroundColor: "skyblue",
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span style={{ fontSize: "1rem", fontWeight: "600" }}>
                    {truncateToFixed(amountPerMonth, 2)} $
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="dashbordItem">
            <div className="dashbordItemUp">
              <div className="dashDesc">
                <div className="descTitle1">Historique journalier</div>
                <div className="descTitle2">Somme perçue aujourd'hui</div>
              </div>
              <div className="dashIcon">
                <div
                  color=""
                  aria-label="add"
                  style={{
                    width: "90px",
                    height: "50px",
                    backgroundColor: "skyblue",
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span style={{ fontSize: "1rem", fontWeight: "600" }}>
                    {truncateToFixed(amountPerDay, 2)} $
                  </span>
                </div>
              </div>
            </div>

            <div className="dashbordItemDown" onClick={onClickHistorique}>
              Afficher l'historique{" "}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Header;
